import { useMemo } from "react";
import { useIntl } from "react-intl";
import { getLanguageFromFullLocale } from "../../../../lib/config";
import { useOccupationsQuery } from "../../../occupation/application/hooks/useOccupationsQuery";

export interface OccupationOption {
  ticker: string;
  name: string;
  seniors: number;
  adults: number;
  juniors: number;
  children: number;
  babies: number;
}

export function useOccupations(propertyTicker: string) {
  const intl = useIntl();
  const locale = useMemo(() => getLanguageFromFullLocale(intl.locale), [intl.locale]);
  const { data, isLoading } = useOccupationsQuery(propertyTicker);

  const occupations = useMemo<OccupationOption[]>(() => {
    if (!data) return [];
    return data.map(occ => {
      const translation = occ.translationsList.find(t => t.locale === locale);
      const name = translation?.name || occ.translationsList[0]?.name || occ.ticker;
      return {
        ticker: occ.ticker,
        name,
        seniors: occ.seniors,
        adults: occ.adults,
        juniors: occ.juniors,
        children: occ.children,
        babies: occ.babies,
      };
    });
  }, [data, locale]);

  return { occupations, loading: isLoading };
}
